import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import { NewClub, registerClub } from "./clubApi";
import ClubRegistrationFields, { EMPTY_CLUB, isClubComplete } from "./ClubRegistrationFields";

function RegisterClubDialog({
  open,
  onClose,
  onRegistered,
  devPort,
  managerId,
}: {
  open: boolean;
  onClose: () => void;
  onRegistered: () => void;
  devPort: string;
  managerId: number;
}) {
  const [club, setClub] = useState<NewClub>(EMPTY_CLUB);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setClub(EMPTY_CLUB);
      setError("");
    }
  }, [open]);

  function submit() {
    setIsSubmitting(true);
    setError("");
    registerClub(devPort, managerId, club)
      .then(onRegistered)
      .catch(() => setError("We couldn't register your club. Please try again."))
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" data-testid="register-club-dialog">
      <DialogTitle>Register a new club</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <ClubRegistrationFields club={club} onChange={setClub} autoFocus />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={submit}
          disabled={!isClubComplete(club) || isSubmitting}
          data-testid="register-club-submit"
        >
          Register
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RegisterClubDialog;
